import * as React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
//import CloudUploadIcon from "@material-ui/icons/CloudUpload";

//import List from "@material-ui/core/List";
//import ListItem from "@material-ui/core/ListItem";
//import ListItemAvatar from "@material-ui/core/ListItemAvatar";
//import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
//import ListItemText from "@material-ui/core/ListItemText";
//import Avatar from "@material-ui/core/Avatar";
//import IconButton from "@material-ui/core/IconButton";
//import PictureAsPdf from "@material-ui/icons/Folder";
//import DeleteIcon from "@material-ui/icons/Delete";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";

import { Attachment } from "../../../../Partials/Attachment/Attachment";
import Component from "../../../../AbstractComponent";
import CompanyLookup from "../../../../Partials/Lookup/CompanyLookup";
import Select from "../../../../Partials/Material/Select";
import TypeContainer from "../../../../../Entity/Entities/Charge/Type/TypeContainer";
import { DatePickerComponent } from "../../../../Partials/DatePicker/DatePickerComponent";
import Time from "../../../../../Time/Time";
import TextField from "../../../../Partials/Material/TextField";
import { calculateBilledMonthFromDates } from "../utils/calculateBilledMonthFromDates";
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

class Bill extends Component {
  public state: Record<string, any> = {
    files: [],
    totalAmount: 0,
    paidAmount: 0,
    administrationPercentageFee: 5,
    errors: {
      company: "",
      chargeTypeForLandlord: "",
      chargeTypeForTenant: "",
      periodFirst: "",
      periodLast: "",
      bill_period: "",
      totalAmount: "",
      paidAmount: "",
      administrationPercentageFee: "",
    },
  };

  constructor(public props) {
    super(props);

    this.state = {
      ...this.state,
      ...this.props.state,
    };

    this.validateField = this.validateField.bind(this);
    this.validateStep = this.validateStep.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.doBillCalculations = this.doBillCalculations.bind(this);
    this.onNextStep = this.onNextStep.bind(this);
    this.onBack = this.onBack.bind(this);
    this.renderChargeTypeSelectForLandlord = this.renderChargeTypeSelectForLandlord.bind(this);
    this.renderChargeTypeSelectForTenant = this.renderChargeTypeSelectForTenant.bind(this);
  }

  public validateField(field, value) {
    switch (field) {
      case "company":
        if (!value)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/company/error/company-missing"
          );
        return null;

      case "chargeTypeForLandlord":
        if (!value)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/utility-bill-type/error/charge-type-for-landlord-missing"
          );
        return null;

        case "chargeTypeForTenant":
          if (!value)
            return this.trans(
              "coach/new-bill-settlement/steps/bill/section-one/utility-bill-type/error/charge-type-for-tenant-missing"
            );
          return null;
  
        case "periodLast":
        if (!value)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-missing"
          );

        if (value > new Date())
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-in-future"
          );

        if (this.state.periodFirst && value < this.state.periodFirst)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-before-start"
          );
        return null;

      case "periodFirst":
        if (!value)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-missing"
          );

        if (value > new Date())
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-in-future"
          );

        if (value < new Date("2000-01-01"))
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-too-early"
          );
        return null;

      case "bill_period":
        // value in milliseconds (periodLast - periodFirst) should be more than 2 years
        if (value > 2 * 366 * 24 * 60 * 60 * 1000) {
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/bill-period/error/bill-period-too-long"
          );
        }
        return null;

      case "totalAmount":
        if (!value)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-missing"
          );

        if (value < 0)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-negative"
          );

        if (value > 100_000) {
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-too-high"
          );
        }
        return null;

      case "paidAmount":
        if (!value && value !== 0)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/paid-amount/error/paid-amount-missing"
          );

        if (value < 0)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/section-one/paid-amount/error/paid-amount-negative"
          );
        return null;

      case "administrationPercentageFee":
        if (!value && value !== 0)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/error/percentage-fee-missing"
          );

        if (value < 0 || value > 100)
          return this.trans(
            "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/error/not-in-range"
          );
        return null;

      default:
        return null;
    }
  }

  public validateStep() {
    const newErrors = {};
    const fields = [
      "company",
      "chargeTypeForLandlord",
      "chargeTypeForTenant",
      "periodFirst",
      "periodLast",
      "totalAmount",
      "paidAmount",
      "administrationPercentageFee",
    ];

    for (const key of fields) {
      const error = this.validateField(key, this.state[key]);
      if (error) newErrors[key] = error;
    }

    if (this.state.periodFirst && this.state.periodLast) {
      const bill_period =
        this.state.periodLast?.getTime() - this.state.periodFirst?.getTime();
      const error = this.validateField("bill_period", bill_period);
      if (error) newErrors["bill_period"] = error;
    }

    return newErrors;
  }

  public onChange(field, value) {
    const newErrors = { ...this.state.errors };
    newErrors[field] = "";

    const fieldError = this.validateField(field, value);
    if (fieldError) newErrors[field] = fieldError;

    if (field === "periodFirst" && this.state.periodLast) {
      const bill_period = this.state.periodLast.getTime() - value.getTime();
      const error = this.validateField("bill_period", bill_period);
      if (error) newErrors["bill_period"] = error;
    }

    if (field === "periodLast" && !!value && this.state.periodFirst) {
      const bill_period = value.getTime() - this.state.periodFirst.getTime();
      const error = this.validateField("bill_period", bill_period);
      if (error) newErrors["bill_period"] = error;
    }

    this.setState({
      ...this.state,
      [field]: value,
      errors: newErrors,
    });
  }

  public handleUpload(event) {
    this.setState({
      ...this.state,
      files: [...(this.state.files || []), ...event.target.files],
    });
  }

  public doBillCalculations() {
    const bill_calculations: Record<string, any> = {};

    const periodFirst = new Date(this.state.periodFirst);
    const periodLast = new Date(this.state.periodLast);

    const numberOfBilledMonths = calculateBilledMonthFromDates({
      firstDate: periodFirst,
      lastDate: periodLast,
    });
    const totalAmount = Number(this.state.totalAmount) || 0;
    const administrationPercentageFee =
      Number(this.state.administrationPercentageFee) || 0;
    const totalSettledAmount =
      totalAmount * (1 + administrationPercentageFee / 100);
    const monthlyPayment = totalSettledAmount / numberOfBilledMonths;

    bill_calculations.total_amount = totalAmount;
    bill_calculations.total_settled_amount = totalSettledAmount;
    bill_calculations.administration_percentage_fee =
      administrationPercentageFee;
    bill_calculations.number_of_billed_months = numberOfBilledMonths;
    bill_calculations.monthly_payment = monthlyPayment;

    return bill_calculations;
  }

  public onNextStep() {
    const newErrors = this.validateStep();

    if (Object.keys(newErrors).length > 0) {
      this.setState({
        ...this.state,
        errors: {
          ...newErrors,
        },
      });
      return;
    }

    this.props.setState({
      ...this.props.state,
      ...this.state,
      bill_calculations: this.doBillCalculations(),

      activeStep: 2,
    });
  }

  public onBack() {
    this.props.setState({
      ...this.props.state,
      ...this.state,
      activeStep: 0,
    });
  }

  public renderChargeTypeSelectForLandlord() {
    const chargeTypes =
      TypeContainer.getPayableTypes(true)
        .filter((type) => {
          if (type.removed) return false;

          if ([-1, -2].includes(type.id)) return false;

          if (
            TypeContainer.pickIdFromLabel("Stub_receivable") === type.id ||
            TypeContainer.pickIdFromLabel("Stub_payable") === type.id
          )
            return false;

          return true;
        })
        .map((type) => ({
          utilityBill: type,
          value: type.id,
          label: this.formatter.checkTranslationType(
            this.trans(type?.label, {}, "", type?.system),
            type?.label,
            type?.system
          ),
        })) || [];

    return (
      <Select
        className="coach_newBillSettlement_step_section_content_item_chargeType"
        label={this.trans(
          "coach/new-bill-settlement/steps/bill/section-one/charge-type-for-landlord/label"
        )}
        disabled={!chargeTypes.length}
        value={this.props.state.chargeTypeForLandlord?.value}
        onChange={(event) =>
          this.onChange(
            "chargeTypeForLandlord",
            chargeTypes.find((type) => type.value === event.target.value)
          )
        }
        error={this.state.errors?.chargeTypeForLandlord || null}
      >
        {chargeTypes.map((type, index) => (
          <MenuItem key={index} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    );
  }

  public renderChargeTypeSelectForTenant() {
    const chargeTypes =
      TypeContainer.getReceivableTypes(true)
        .filter((type) => {
          if (type.removed) return false;

          if ([-1, -2].includes(type.id)) return false;

          if (
            TypeContainer.pickIdFromLabel("Stub_receivable") === type.id ||
            TypeContainer.pickIdFromLabel("Stub_payable") === type.id
          )
            return false;

          return true;
        })
        .map((type) => ({
          utilityBill: type,
          value: type.id,
          label: this.formatter.checkTranslationType(
            this.trans(type?.label, {}, "", type?.system),
            type?.label,
            type?.system
          ),
        })) || [];

    return (
      <Select
        className="coach_newBillSettlement_step_section_content_item_chargeType"
        label={this.trans(
          "coach/new-bill-settlement/steps/bill/section-one/charge-type-for-tenant/label"
        )}
        disabled={!chargeTypes.length}
        value={this.props.state.chargeTypeForTenant?.value}
        onChange={(event) =>
          this.onChange(
            "chargeTypeForTenant",
            chargeTypes.find((type) => type.value === event.target.value)
          )
        }
        error={this.state.errors?.chargeTypeForTenant || null}
      >
        {chargeTypes.map((type, index) => (
          <MenuItem key={index} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    );
  }

  public render() {
    return (
      <div className="coach_newBillSettlement_step_wrapper">
        {/* bill step title (address / property) */}
        <div className="coach_newBillSettlement_step_title">
          {this.props.state.address?.displayName ?? ""}
        </div>

        {/* bill's details */}
        <div className="coach_newBillSettlement_step_section">
          <div className="coach_newBillSettlement_step_section_header">
            <div className="coach_newBillSettlement_step_section_header_title">
              {this.trans(
                "coach/new-bill-settlement/steps/bill/section-one/title"
              )}
            </div>
          </div>

          <div className="coach_newBillSettlement_step_section_content">
            {/* company */}
            <div className="coach_newBillSettlement_step_section_content_item">
              <CompanyLookup
                {...this.props}
                id="company"
                name="company"
                ref="company"
                floatingLabelText={this.trans(
                  "dropdown-searchforcompany-label"
                )}
                isInlineBlock={false}
                includeAgency={true}
                onSelect={(value) => this.onChange("company", value)}
                onClear={() => this.onChange("company", null)}
                error={this.state.errors?.company || null}
                autoSelectId={this.state.company?.id}
                disableEntityCreation={true}
              />
            </div>

            {/* utility */}
            <div className="coach_newBillSettlement_step_section_content_item">
              {this.renderChargeTypeSelectForLandlord()}
            </div>

            {/* utility */}
            <div className="coach_newBillSettlement_step_section_content_item">
              {this.renderChargeTypeSelectForTenant()}
            </div>

            {/* dates */}
            <div className="coach_newBillSettlement_step_section_content_item">
              <div className="coach_newBillSettlement_step_section_content_item_row">
                <div className="coach_newBillSettlement_step_section_content_item_row_col" style={{width: "20em"}}>
                  <DatePickerComponent
                    {...this.props}
                    id="periodFirst"
                    name="periodFirst"
                    label={this.trans("first-date") + Time.getDatepickerHint()}
                    initialDate={this.state.periodFirst || null}
                    onChange={(value) => this.onChange("periodFirst", value)}
                    error={this.state.errors?.periodFirst || null}
                  />
                </div>
                <div className="coach_newBillSettlement_step_section_content_item_row_col" style={{width: "20em"}}>
                  <DatePickerComponent
                    {...this.props}
                    id="periodLast"
                    name="periodLast"
                    label={this.trans("last-date") + Time.getDatepickerHint()}
                    initialDate={this.state.periodLast || null}
                    onChange={(value) => this.onChange("periodLast", value)}
                    maxDate={new Date()}
                    error={this.state.errors?.periodLast || null}
                  />
                </div>
              </div>

              {/* show errors */}
              {/*
              <div className="coach_newBillSettlement_step_section_content_item_row">
                {this.state.errors?.periodFirst && (
                  <div className="coach_newBillSettlement_step_section_content_item_row_error">
                    {this.state.errors.periodFirst}
                  </div>
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row">
                {this.state.errors?.periodLast && (
                  <div className="coach_newBillSettlement_step_section_content_item_row_error">
                    {this.state.errors.periodLast}
                  </div>
                )}
              </div>
              */}
              <div className="coach_newBillSettlement_step_section_content_item_row">
                {this.state.errors?.bill_period && (
                  <div className="coach_newBillSettlement_step_section_content_item_row_error">
                    {this.state.errors.bill_period}
                  </div>
                )}
              </div>
            </div>

            {/* amounts */}
            <div className="coach_newBillSettlement_step_section_content_item">
              <div className="coach_newBillSettlement_step_section_content_item_row">
                <FormControl>
                  <TextField
                    style={{width: "20em"}}
                    label={this.trans("coach/new-bill-settlement/steps/bill/section-one/total-amount/label")}
                    fullWidth={true}
                    type="number"
                    error={this.state.errors?.totalAmount || ""}
                    value={this.state.totalAmount || ""}
                    onChange={(e) => this.onChange("totalAmount", Number(e.target.value) || "")}
                  >
                  </TextField>
                  {!!this.state.errors?.totalAmount && <FormHelperText error={true}>{this.state.errors.totalAmount}</FormHelperText>}
                </FormControl>

                <Select
                  id="currency"
                  name="currency"
                  className="coach_newBillSettlement_step_section_content_item_currency"
                  value={"EUR"}
                  error={""}
                  disabled={true}
                >
                  <MenuItem value="EUR">EUR</MenuItem>
                </Select>
              </div>
              {/*
              <div className="coach_newBillSettlement_step_section_content_item_row">
                {this.state.errors?.totalAmount && (
                  <div className="coach_newBillSettlement_step_section_content_item_row_error">
                    {this.state.errors.totalAmount}
                  </div>
                )}
              </div>
              */}
            </div>
            <div className="coach_newBillSettlement_step_section_content_item">
              <div className="coach_newBillSettlement_step_section_content_item_row">
              <FormControl>
              <TextField
                  style={{width: "20em"}}
                  label={this.trans("coach/new-bill-settlement/steps/bill/section-one/paid-amount/label")}
                  fullWidth={true}
                  type="number"
                  error={this.state.errors?.paidAmount || ""}
                  value={this.state.paidAmount === 0 ? 0 : this.state.paidAmount || ""}
                  onChange={(e) =>this.onChange("paidAmount", Number(e.target.value))}
                >
                </TextField>
                {!!this.state.errors?.paidAmount && <FormHelperText error={true}>{this.state.errors.paidAmount}</FormHelperText>}
                </FormControl>
                <Select
                  id="currency"
                  name="currency"
                  className="coach_newBillSettlement_step_section_content_item_currency"
                  value="EUR"
                  error=""
                  disabled={true}
                >
                  <MenuItem value="EUR">EUR</MenuItem>
                </Select>
              </div> {/*
              <div className="coach_newBillSettlement_step_section_content_item_row">
                {this.state.errors?.paidAmount && (
                  <div className="coach_newBillSettlement_step_section_content_item_row_error">
                    {this.state.errors.paidAmount}
                  </div>
                )}
              </div> */}
            </div>
          </div>
        </div>

        {/* landlord fees */}
        <div className="coach_newBillSettlement_step_section">
          <div className="coach_newBillSettlement_step_section_header">
            <div className="coach_newBillSettlement_step_section_header_title">
              {this.trans(
                "coach/new-bill-settlement/steps/bill/landlord-section/title"
              )}
            </div>
          </div>

          <div className="coach_newBillSettlement_step_section_content">
            <div className="coach_newBillSettlement_step_section_content_item">
              <div className="coach_newBillSettlement_step_section_content_item_row">
                <FormControl>
                <TextField
                  label={this.trans(
                    "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/label"
                  )}
                  type="number"
                  endAdornment={true}
                  error={this.state.errors.administrationPercentageFee || ""}
                  value={this.state.administrationPercentageFee === 0 ? 0 : this.state.administrationPercentageFee || "" }
                  onChange={(e) => this.onChange("administrationPercentageFee", Number(e.target.value))}
                >
                </TextField>
                {!!this.state.errors?.administrationPercentageFee && <FormHelperText error={true}>{this.state.errors.administrationPercentageFee}</FormHelperText>}
                </FormControl>
              </div> {/*
              <div className="coach_newBillSettlement_step_section_content_item_row">
                {this.state.errors?.administrationPercentageFee && (
                  <div className="coach_newBillSettlement_step_section_content_item_row_error">
                    {this.state.errors.administrationPercentageFee}
                  </div>
                )}
              </div> */}
            </div>
          </div>
        </div>

        {/* documents */}
        <div className="coach_newBillSettlement_step_section">
        <Attachment
          {...this.props}
          title={this.trans("coach/new-bill-settlement/steps/bill/documents/title")}
          buttonTitle = {this.trans("coach/new-bill-settlement/steps/bill/documents/upload")}
          typeOfComponent="shared"
          possibilityToSetAvatar={true}
          relation="chargeId"
          attachments={this.props.state.attachments}
          updateParentState={this.props.onAttachmentsUpdated}
        />
        </div>

        {/* back / next buttons */}
        <div className="coach_newBillSettlement_actionButtons">
          <Button
            variant="contained"
            onClick={this.onBack}
            startIcon={<ArrowBackIos />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/back")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onNextStep}
            endIcon={<ArrowForwardIosIcon />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/next")}
          </Button>
        </div>
      </div>
    );
  }
}

export default Bill;
